import React from "react";
import { useTranslation } from "react-i18next";

import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    width: 300,
    maxWidth: 300,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      maxWidth: "100%",
      minWidth: "100%"
    }
  },
  image: {
    height: theme.spacing(5),
    width: theme.spacing(5),
    marginRight: theme.spacing(3)
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18
    }
  }
}));

function Dropdown({
  focus,
  id,
  inputRef,
  label,
  onChange,
  options,
  translationKey,
  value
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Autocomplete
      id={id || "dropdown"}
      options={options}
      className={classes.root}
      classes={{
        option: classes.option
      }}
      autoHighlight
      getOptionLabel={option => t(`${translationKey}.${option.name}`)}
      openOnFocus
      ref={inputRef}
      renderOption={option => (
        <React.Fragment>
          {option.image ? (
            <img
              className={classes.image}
              src={option.image}
              alt={t(`${translationKey}.${option.name}`)}
            />
          ) : null}
          <span>{t(`${translationKey}.${option.name}`)}</span>
          {/* {option.label} ({option.code}) +{option.phone} */}
        </React.Fragment>
      )}
      onChange={(event, newValue) => {
        if (onChange) onChange(newValue);
      }}
      renderInput={params => (
        <TextField
          {...params}
          autoFocus={focus}
          label={label}
          variant="outlined"
          inputProps={{
            ...params.inputProps,
            autoComplete: "new-password" // disable autocomplete and autofill
          }}
        />
      )}
      value={value}
    />
  );
}

export default Dropdown;
